import { markAsViewed } from "../services/stories";
export default function useStories() {
  async function markViewedMany(newsIds: number[]): Promise<boolean> {
    const responseCode = await markAsViewed(newsIds);

    return responseCode === 201;
  }
  return {
    markViewedMany,
  };
}
